import { render, staticRenderFns } from "./ParentFieldViewerComponent.vue?vue&type=template&id=4ecfd5b6&"
import script from "./ParentFieldViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ParentFieldViewerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports